import React from 'react'

import Cookies from 'js-cookie'
import { useTranslation } from 'react-i18next'

import { Link } from './Link'
import { SectionText } from './SectionText'

export const Footer: React.FC = () => {
    const { t } = useTranslation()
    const resetCookies = () => {
        Cookies.remove('cookie_consent')
        window.location.reload()
    }
    return (
        <footer
            className="bg-secondary-green min-h-[250px] py-3 px-3
            sm:h-auto sm:px-3 sm:py-3">
            <div className="container mx-auto w-full h-full flex flex-col md:flex-row justify-between items-center text-white">
                <div className="max-w-1/3 h-full flex items-center justify-center text-center md:text-left">
                    <SectionText title={t('footer.contact.title')} hrLineColor="bg-primary-blue" discoverMore={false}>
                        {t('footer.contact.address')} <br />
                        {t('footer.contact.city')} <br /> <br />
                        {t('imprint.contact.phone')}{' '}
                        <a href="tel:+496514604488" className="hover:underline">
                            {' '}
                        </a>{' '}
                        <br />
                        {t('imprint.contact.fax')} <br />
                        <a href="mailto:termin@kinderchirurgie-trier.de" className="hover:underline">
                            {t('footer.contact.email')}
                        </a>{' '}
                        <br />
                    </SectionText>
                </div>
                <div className="flex flex-col space-y-1 items-center md:items-start my-3">
                    <Link href="/#about-me">{t('navigation.aboutMe')}</Link>
                    <Link href="/#services">{t('navigation.services')}</Link>
                    <Link href="/#office-hours">{t('navigation.officeHours')}</Link>
                    <Link href="/#contact">{t('navigation.contact')}</Link>
                    <Link href="/#team">{t('navigation.team')}</Link>
                    <Link href="/#download">{t('navigation.download')}</Link>
                </div>
                <div className="flex flex-col space-y-1 items-center md:items-start my-3">
                    <Link href="/imprint">{t('imprint.title')}</Link>
                    <Link href="/privacy">{t('footer.links.privacy')}</Link>
                    <Link href="#" onClick={resetCookies}>
                        {t('footer.links.cookieSettings')}
                    </Link>
                </div>
            </div>
        </footer>
    )
}
